import { TSType } from '../../models'
import { CustomFields } from '../../models/CustomFields'

export interface ICustomFieldProps {
  isUnits: boolean
  sType: TSType
  isSoB: boolean
}

export const getJustifyField = ({ isSoB, isUnits, sType }: ICustomFieldProps): string => {
  let justifyField = isUnits ? CustomFields.JustifyUnits : CustomFields.Justify

  if (isSoB) {
    justifyField = CustomFields.JustifySob
  } else if (sType) {
    if (isUnits) {
      justifyField = sType === 't' ? CustomFields.JustifyUnitsT : CustomFields.JustifyUnitsC
    } else {
      justifyField = sType === 't' ? CustomFields.JustifyT : CustomFields.JustifyC
    }
  }

  return justifyField
}
